import { useState, useEffect } from 'react';

export default function StickyWhatsApp() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPulse(true);
      setTimeout(() => setPulse(false), 1000);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <a
      href="https://wa.me/903222286464?text=Merhaba!%20Bilgi%20almak%20istiyorum."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      className={`fixed bottom-6 right-4 md:right-8 z-50 transition-all duration-500 cursor-pointer ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
    >
      <div className="relative">
        {/* Pulse ring */}
        {pulse && (
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        )}
        {/* Button */}
        <div className="relative w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] rounded-full shadow-2xl shadow-[#25D366]/40 transition-all transform hover:scale-110">
          <i className="ri-whatsapp-fill text-white text-2xl md:text-3xl" />
        </div>
        {/* Notification dot */}
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#FF4500] rounded-full border-2 border-[#0a0a0a] flex items-center justify-center">
          <span className="text-white text-[8px] font-black">1</span>
        </span>
      </div>
    </a>
  );
}
